module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.5-103.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.3.5.md
// module id = 521
// module chunks = 303